import axios from 'axios';
import { postFiles } from '../util/axios';

export const apiUpdateRegistration = (id, payload) => axios.patch(`/api/registration/${id}`, payload);
export const apiGetRegistration = (id) => axios.get(`/api/registration/${id}`);
export const apiGetRegistrations = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/registrations`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiAddFile = (id, payload) => postFiles(`/api/registration/${id}/file`, payload);
export const apiProcessPayment = (id, { token, ...payload }) =>
  axios.post(`/api/registration/${id}/payment`, { stripeToken: token, ...payload });
export const apiSubmitRegistration = (id) => axios.post(`/api/registration/${id}`);
export const apiPayExamFees = (id, { token, ...payload }) =>
  axios.post(`/api/registration/${id}/exam`, { stripeToken: token, ...payload });
export const apiPayRetakeFees = (id, { token, ...payload }) =>
  axios.post(`/api/registration/${id}/retake`, { stripeToken: token, ...payload });
export const apiPayModuleFees = (id, { token, ...payload }) =>
  axios.post(`/api/registration/${id}/module`, { stripeToken: token, ...payload });
export const apiApproveRegistration = (id, payload) => axios.post(`/api/registration/${id}/approve`, payload);
export const apiApproveModule = (id, payload) => axios.post(`/api/registration/${id}/approve/module`, payload);
export const apiRejectRegistration = (id, payload) => axios.post(`/api/registration/${id}/reject`, payload);
export const apiSimulatePassedExam = (id) => axios.post(`/api/registration/${id}/pass-exam`);
export const apiSimulateFailedExam = (id) => axios.post(`/api/registration/${id}/fail-exam`);
export const apiDeleteRegistration = (id) => axios.delete(`/api/registration/${id}`);
export const apiViewCanvasSectionsForRegistrationCourseMaterials = (id) =>
  axios.get(`/api/admin/registration/${id}/material/section`);
export const apiViewCanvasSectionsForModule = (id, moduleId) =>
  axios.get(`/api/admin/registration/${id}/module/${moduleId}/section`);
export const apiEnrollInCanvasSectionsForModule = (id, moduleId, payload) =>
  axios.post(`/api/admin/registration/${id}/module/${moduleId}/section`, payload);

export const apiOverridePrice = (registrationId, { id, ...payload }) =>
  axios.patch(`/api/registration/${registrationId}/lineItem/${id}`, payload);

export const apiAddExamAttempt = (registrationId, exam) =>
  axios.post(`/api/admin/registration/${registrationId}/exam/${exam}`);
export const apiUpdateExamResult = (registrationId, { id, ...payload }) =>
  axios.patch(`/api/admin/registration/${registrationId}/exam/${id}`, payload);
export const apiDeleteExamResult = (registrationId, id) =>
  axios.delete(`/api/admin/registration/${registrationId}/exam/${id}`);
